import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PUCCLOGO from '../../images/UCC_EP_WHITE.png'
import DynamicZoneMainHeader from '../../helpers/dynamicZoneMainHeader'
import useAllSitePage from '../../hooks/useAllSitePage'
import Icon from '../../shared/Icon/Icon'
import { useTheme } from '../../context/themeContext'
import { InternalLink } from '../../shared/Links/InternalLink'
import { ExternalLink } from '../../shared/Links/ExternalLink'
import './Header.scss'

const Header = ({ screenData, homeData }) => {

  const pagesPath = useAllSitePage()

  const {
    allSitePage: matchPages
  } = pagesPath

  const { theme, toggleTheme } = useTheme()

  const careerFeedByLevel = [
    {
      name: "Doctorados",
      slug: "/propuesta-academica?nivel=Doctorados"
    },
    {
      name: "Maestrías",
      slug: "/propuesta-academica?nivel=Maestrías"
    },
    {
      name: "Especializaciones",
      slug: "/propuesta-academica?nivel=Especializaciones"
    },
    {
      name: "Especialidades Médicas",
      slug: "/propuesta-academica/especialidades-medicas"
    },
    {
      name: "Ver Propuesta Académica",
      slug: "/propuesta-academica"
    },
  ]

  return (
    <header className="fixed-top">
      <Navbar
        expand="lg"
        className="shadow flex-lg-column me-auto pt-lg-3 px-3 navbar nav-primary-container navbar-scroll navbar-scroll-style2"
        variant={theme}
      >
        <div className="w-100 d-flex flex-column flex-lg-row">
          <div className="flex-grow-1 d-flex flex-row align-items-center">
            {/* Imagen del Navbar */}
            <Navbar.Brand>
              <Link to="/">
                <img
                  src={
                    theme === 'dark' && screenData?.logo?.imageDark
                      ? screenData?.logo?.imageDark.url
                      : theme === 'dark' && homeData?.secondaryLogoDark
                        ? homeData?.secondaryLogoDark.image.url
                        : theme === 'light' && screenData?.logo?.imageLight
                          ? screenData?.logo?.imageLight.url
                          : PUCCLOGO
                  }
                  alt={screenData?.logo?.title || 'UCC'}
                  className="logoHeader me-2"
                />
              </Link>
            </Navbar.Brand>

            {/* Mobile Navbar */}
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="ms-auto pr-0 border-0 nav-primary-color"
            />
          </div>

          {/* Button theme on laptop */}
          <div className="d-flex flex-column">
            <div className="flex-grow-1 d-none d-lg-flex align-items-center justify-content-start justify-content-md-end navbar-nav fw-bolder nav-primary">
              <div className="d-flex">
                <div className="nav-primary-color">
                  <button onClick={toggleTheme} className="theme-toggle">
                    {theme === 'dark' ? <FontAwesomeIcon icon="fa-solid fa-moon" /> : <FontAwesomeIcon icon="fa-solid fa-sun" />}
                  </button>
                </div>
              </div>
              <DynamicZoneMainHeader 
                homeData={homeData}
                matchPages={matchPages} 
              />
            </div>
          </div>
        </div>

        <Navbar.Collapse id="basic-navbar-nav" className="w-100">
          {/* Button theme on mobile */}
          <div className="row">
            <div className="col">
              <div className="d-lg-none d-flex align-items-center justify-content-start justify-content-md-end navbar-nav border-top border-bottom py-3 fw-bolder nav-primary">
                <div className="d-lg-none d-flex">
                  <div className="btn-sm nav-primary-color">
                    <button onClick={toggleTheme} className="theme-toggle">
                      {theme === 'dark' ? <FontAwesomeIcon icon="fa-solid fa-moon" /> : <FontAwesomeIcon icon="fa-solid fa-sun" />}
                    </button>
                  </div>
                </div>
                <DynamicZoneMainHeader 
                  homeData={homeData}
                  matchPages={matchPages} 
                />
              </div>
            </div>
          </div>

          <Nav
            id='header-navbar'
            className="me-auto flex-column flex-lg-row link-dropdown-dark"
          >
            {screenData?.navbar?.map((menuItem, index) => {
              if (
                (menuItem.p_ucc_microsite && menuItem.p_ucc_microsite !== null) ||
                (menuItem.p_ucc_page && menuItem.p_ucc_page !== null) ||
                (menuItem.p_ucc_career && menuItem.p_ucc_career !== null) ||
                (menuItem.url && menuItem.url !== null)
              ) {
                /********* Map para navItems simples *********/
                if (menuItem.p_ucc_microsite && menuItem.p_ucc_microsite.slug) {
                  return (
                    <InternalLink
                      key={'internalLink-navbar-microsite-' + index}
                      data={menuItem}
                      matchPages={matchPages}
                      icon={menuItem.icon}
                    />
                  )
                } else if (menuItem.p_ucc_page && menuItem.p_ucc_page?.slug) {
                  return (
                    <InternalLink
                      key={'internalLink-navbar-page-' + index}
                      data={menuItem}
                      matchPages={matchPages}
                      icon={menuItem.icon}
                    />
                  )
                } else if (menuItem.p_ucc_career && menuItem.p_ucc_career?.slug) {
                  return (
                    <InternalLink
                      key={'internalLink-navbar-career-' + index}
                      data={menuItem}
                      matchPages={matchPages}
                      icon={menuItem.icon}
                    />
                  )
                } else if (menuItem.url) {
                  return (
                    <ExternalLink
                      key={'externalLink-navbar-' + index}
                      data={menuItem}
                      icon={menuItem.icon}
                    />
                  )
                } else return null
              } else if (
                /********* Map para navItems dropdowns - Multiple Options *********/
                menuItem.pUccMicrosite?.find((item) => item.p_ucc_microsite.slug !== null) ||
                menuItem.pUccPages?.find((item) => item.p_ucc_page.slug !== null) ||
                menuItem.__component === "menu.p-ucc-career-list" ||
                menuItem.__component === "menu.pucc-career-feed-by-level" ||
                menuItem.ExternalLink?.find((item) => item.url !== null) ||
                menuItem.multipleSite
              ) {
                return (
                  <NavDropdown
                    title={`${menuItem.name}`}
                    id="basic-nav-dropdown"
                    key={`navBarId-${index}`}
                    className="text-uppercase header-navdropdown"
                  >
                    {/* Map PUCC Pages */}
                    {menuItem.pUccPages &&
                      menuItem.pUccPages?.map((dropdown, index) => {
                        if (dropdown.p_ucc_page.slug) {
                          return (
                            <div className="nav-scroll navbar-scroll-style2" key={'internalLink-navbar-page-' + index}>
                              <InternalLink
                                data={dropdown}
                                matchPages={matchPages}
                                icon={dropdown.icon}
                              />
                            </div>
                          )
                        }
                        return null
                      })
                    }

                    {/* Map PUCC Microsites */}
                    {menuItem.pUccMicrosite &&
                      menuItem.pUccMicrosite?.map((dropdown, index) => {
                        if (dropdown.p_ucc_microsite.slug) {
                          return (
                            <div className="nav-scroll navbar-scroll-style2" key={'internalLink-navbar-microsite-' + index}>
                              <InternalLink
                                data={dropdown}
                                matchPages={matchPages}
                                icon={dropdown.icon}
                              />
                            </div>
                          )
                        }
                        return null
                      })
                    }

                    {/* Map PUCC Carrers */}
                    {menuItem.__component === "menu.p-ucc-career-list" && (
                      <>
                        {screenData?.p_ucc_careers?.map((dropdown, index) => {
                          // career_category ID Esp Cs Salud = 8 ID PROD / 12 ID DEV 
                          if (dropdown.slug && dropdown.career_category !== 8) {
                            return (
                              <div key={`menuCareersId-${index}`} className="nav-scroll navbar-scroll-style2">
                                <Link to={`/carreras/${dropdown?.slug}`} className="dropdown-item">
                                  <div className="text-wrap-lg text-uppercase mb-0 d-flex flex-row">
                                    <small className="nav-text">{dropdown?.name}</small>
                                  </div>
                                </Link>
                              </div>
                            );
                          }

                          return null;
                        })}

                        {/* Componente adicional al final del map */}
                        {screenData.slug === "salud-ambiente" && (
                          <div className="nav-scroll navbar-scroll-style2">
                            <Link to="/propuesta-academica/especialidades-medicas" className="dropdown-item">
                              <div className="text-wrap-lg text-uppercase mb-0 d-flex flex-row">
                                <small className="nav-text">Especialidades Médicas</small>
                              </div>
                            </Link>
                          </div>
                        )}
                      </>
                    )}

                    {/* Map PUCC Career Feed By Level */}
                    {menuItem.__component === "menu.pucc-career-feed-by-level" &&
                      careerFeedByLevel.map((level, index) => {
                        return (
                          <div className="nav-scroll navbar-scroll-style2" key={`menuCareerFeedByLevelId-${index}`}>
                            <Link
                              to={`${level.slug}`}
                              className="dropdown-item"
                            >
                              <div className="text-wrap-lg text-uppercase mb-0 d-flex flex-row">
                                <small className="nav-text">
                                  {level.name}
                                </small>
                              </div>
                            </Link>
                          </div>
                        )
                      })
                    }

                    {/* Map external links */}
                    {menuItem.ExternalLink &&
                      menuItem.ExternalLink?.map((dropdown, index) => {
                        if (dropdown?.url) {
                          return (
                            <div className="nav-scroll navbar-scroll-style2" key={'externalLink-navbar-' + index}>
                              <ExternalLink
                                data={dropdown}
                                icon={dropdown.icon}
                              />
                            </div>
                          )
                        }
                        return null
                      })
                    }

                    {/* Map MultipleSites */}
                    {menuItem.multipleSite &&
                      <div className="nav-scroll navbar-scroll-style2">
                        {menuItem.multipleSite?.map((dropdown, index) => {
                          switch (true) {
                            case dropdown.p_ucc_page !== null:
                              return (
                                <InternalLink
                                  key={'internalLink-navbar-page-' + index}
                                  data={dropdown}
                                  matchPages={matchPages}
                                  icon={dropdown.icon}
                                />
                              )

                            case dropdown.p_ucc_microsite !== null:
                              return (
                                <InternalLink
                                  key={'internalLink-navbar-microsite-' + index}
                                  data={dropdown}
                                  matchPages={matchPages}
                                  icon={dropdown.icon}
                                />
                              )

                            case dropdown.url !== null:
                              return (
                                <ExternalLink
                                  key={'externalLink-navbar-' + index}
                                  data={dropdown}
                                  icon={dropdown.icon}
                                />
                              )

                            case dropdown.p_ucc_career !== null:
                              return (
                                <Link
                                  to={`/carreras/${dropdown.ucc_career?.slug}`}
                                  className="dropdown-item"
                                  key={`menuCareerId-${index}`}
                                >
                                  <h6 className="text-wrap-lg text-uppercase mb-0 py-2 d-flex flex-row">
                                    <Icon
                                      {...dropdown.icon}
                                      hasMargin={dropdown.ucc_career?.name.trim()}
                                    />
                                    <small className="nav-text">
                                      {dropdown?.name || dropdown.ucc_career?.name}
                                    </small>
                                  </h6>
                                </Link>
                              )

                            default:
                              return null
                          }
                        })}
                      </div>
                    }
                  </NavDropdown>
                )
              } else return null
            })}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  )
}

export default Header

Header.propTypes = {
  screenData: PropTypes.object.isRequired,
  logo: PropTypes.object
}
